import { parseJSON } from 'date-fns';
import { isDateInPast } from './dateUtils';

export const isPremiumUserCheck = subscriptionData => {
  const { subscription } = subscriptionData;

  return !!subscription;
};

export const isSubscriptionExpiredCheck = subscriptionData => {
  const { subscription, subscription_end_at } = subscriptionData;

  return (
    !!subscription &&
    (subscription_end_at === null ||
      isDateInPast(parseJSON(subscription_end_at)))
  );
};
